import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorBankRequest, VendorResponse } from 'src/app/models/vendor.model';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.scss']
})
export class VendorsComponent {
  categorySelected = null;
  vendors: VendorResponse[] = [];
  creating = false;
  modalVendorBank = false;
  vendorBankToEdit: VendorBankRequest = null;
  editing = false;;
  newVendor: VendorResponse = new VendorResponse();
  filterVendors: VendorResponse[] = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  searchVendor = "";
  alwaysCreating = false;

  constructor(
    private vendorService: VendorService,
    private toastService: ToastrService
  ) {

  }

  getAllVendors() {
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        this.vendors = response.data as VendorResponse[];
        this.resetPagination();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  resetPagination() {
    var newPosition = this.pagination.pageSize*this.pagination.pageIndex;
    this.pagination.total = this.vendors;
    this.pagination.filter = this.vendors.slice(newPosition, newPosition + this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  resetNewFamily() {
    this.newVendor = new VendorResponse();
  }

  cancelNewFamily() {
    if (!this.alwaysCreating) {
      this.creating = false
    }
    this.resetNewFamily();
  }

  ngOnInit(): void {
    this.getAllVendors();
  }


  editAndSave(vendor: any, isCreating: boolean) {
    if (!isCreating) {
      this.vendorService.getCategoriesVendor(vendor.id).subscribe({
        next: (response: ResponseObject) => {
          this.newVendor = vendor;
          this.newVendor['categories'] = response.data;
          this.newVendor.provIn = this.newVendor.inventarios;
          this.creating = false;
          this.editing = true;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las categorias del proveedor");
        }
      })
    } else {
      this.newVendor = new VendorResponse();
      this.creating = true;
      this.editing = false;
    }

  }

  createEditVendorBank(vendor: any) {
    this.vendorBankToEdit = new VendorBankRequest();
    this.modalVendorBank = true;
    this.newVendor = vendor;
  }


  closeModalVendorBank(success: boolean) {
    this.modalVendorBank = false;
    this.vendorBankToEdit = null;
  }


  closeModalProvider() {
    this.creating = false;
    this.editing = false;
    this.getAllVendors();
  }

  activeOrInactive(vendor: any) {
    this.vendorService.delete(vendor).subscribe({
      next: (response: any) => {
        vendor.enabled = !vendor.enabled;
        this.toastService.success("Se ha " + ((vendor.enabled) ? 'activado' : 'desactivado') + " correctamente a la persona");
      },
      error: (error: any) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  searching() {
    this.pagination.total = this.vendors.filter((vendor) => {
      return vendor.id + '' == this.searchVendor || vendor.nit.includes(this.searchVendor) || vendor.name.toLowerCase().includes(this.searchVendor.toLowerCase())
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }
}
